import * as Yup from "yup"

import {
	AssetType,
	ContractType,
	PositionType,
} from "models"

export class ProposalsAdvancedSearchForm
{
	position: PositionType|null|"" = null
	assetType: AssetType|null|"" = null
	shopWindows: number|null = null
	contractType: ContractType|null|"" = null
	minPrice: number|null = null
	maxPrice: number|null = null
	divisible: boolean|null = null
	airConditioning: boolean|null = null
	parkingSlots: boolean|null = null
}

const ProposalsAdvancedSearchValidation = {
	shopWindows: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
	minPrice: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
	maxPrice: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
}

export default Yup.object()
	.shape(
		ProposalsAdvancedSearchValidation,
	)
	.required()
